import * as Yup from "yup";

export const validation = (t) =>
    Yup.object({
        name: Yup.string()
            .max(64, `${t("registration.maxLength")}64`)
            .required(t("registration.required")),
        legal_address: Yup.string().max(128, `${t("registration.maxLength")}128`),
        post_address: Yup.string().max(128, `${t("registration.maxLength")}128`),
        payer_number: Yup.string()
            .matches(/^\d+$/, t("registration.onlyDigits"))
            .required(t("registration.required")),
        phone: Yup.string()
            .min(5, `${t("registration.minLength")}5`)
            .max(15, `${t("registration.maxLength")}15`),
        email: Yup.string()
            .email(t("registration.invalidEmail"))
            .max(32, `${t("registration.maxLength")}32`),
        creation_date: Yup.date().typeError(t("must_be_date")),
    });
